var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLighttheme({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185,
    height: 110,
    viewBox: "0 0 185 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2061",
    "data-name": "Group 2061",
    transform: "translate(-30 -129)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8205",
    "data-name": "Rectangle 8205",
    width: 185,
    height: 110,
    rx: 5,
    transform: "translate(30 129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8208",
    "data-name": "Rectangle 8208",
    width: 147,
    height: 45,
    rx: 5,
    transform: "translate(42 141)",
    fill: "#171717",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8209",
    "data-name": "Rectangle 8209",
    width: 138,
    height: 6,
    rx: 2,
    transform: "translate(51 194)",
    fill: "#171717",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8212",
    "data-name": "Rectangle 8212",
    width: 6,
    height: 6,
    rx: 3,
    transform: "translate(42 194)",
    fill: "#171717",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8210",
    "data-name": "Rectangle 8210",
    width: 138,
    height: 6,
    rx: 2,
    transform: "translate(51 206)",
    fill: "#171717",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8213",
    "data-name": "Rectangle 8213",
    width: 6,
    height: 6,
    rx: 3,
    transform: "translate(42 206)",
    fill: "#171717",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8211",
    "data-name": "Rectangle 8211",
    width: 138,
    height: 6,
    rx: 2,
    transform: "translate(51 218)",
    fill: "#171717",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8214",
    "data-name": "Rectangle 8214",
    width: 6,
    height: 6,
    rx: 3,
    transform: "translate(42 218)",
    fill: "#171717",
    opacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighttheme);
export default __webpack_public_path__ + "static/media/lighttheme.cfe4c1e1d721386df177890d98fc7d36.svg";
export { ForwardRef as ReactComponent };